import {StagingTitelineAppPacking} from "../types/StagingTitelineAppPacking";
import {PackingData} from "../types/PackingData";
import { getApiUrl } from '../config/api';

export const fetchPackingByPid = async (pid?: number, aid: number = -1): Promise<PackingData[]> => {
    const validPid = pid ?? -1;
    const apiUrl = getApiUrl(`/api/TitelinePacking/GetPackingByPid/${validPid}`);

    try {
        const response = await fetch(apiUrl, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });

        if (!response.ok) {
            if (response.status === 404) {
                console.warn(`No packing found for Pid: ${validPid} (404 Not Found)`);
            } else {
                console.error(`Error fetching packing for Pid: ${validPid} - ${response.status} ${response.statusText}`);
            }
            return [];
        }

        let backendData: StagingTitelineAppPacking[] = await response.json();
        if (pid === -1) {
            backendData = backendData.filter((packing) => packing.DataSource === aid.toString());
        }

        return backendData.map((packing) => ({
            key: packing.PackId,
            pack_id: packing.PackId,
            pid: packing.Pid,
            hole_id: packing.HoleID,
            depth: packing.Depth,
            plugged: packing.Plugged,
            comment: packing.Comment,
        }));

    } catch (error) {
        console.error("Error in FetchPackingByPid API call:", error);
        return [];
    }
};

export const addPackingRow = async (packingRow: PackingData, aid: number = -1) => {
    const apiUrl = getApiUrl('/api/TitelinePacking/AddPacking');

    const packingPayload = [
        {
            Pid: packingRow.pid,
            HoleID: packingRow.hole_id,
            Depth: packingRow.depth,
            Plugged: packingRow.plugged,
            Comment: packingRow.comment,
            DataSource: aid,
        },
    ];

    try {
        const response = await fetch(apiUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(packingPayload),
        });

        if (response.ok) {
            console.log("Packing row added to cloud successfully.");
            return true;
        } else {
            console.error("Failed to add packing row:", response.status, response.statusText);
            return false;
        }
    } catch (error) {
        console.error("Error in AddPackingRow API call:", error);
        return false;
    }
};

export const updatePackingRow = async (pack_id: number, updatedRow: PackingData) => {
    const apiUrl = getApiUrl(`/api/TitelinePacking/UpdatePackingByPackId/${pack_id}`);

    const payload = {
        HoleID: updatedRow.hole_id,
        Depth: updatedRow.depth,
        Plugged: updatedRow.plugged,
        Comment: updatedRow.comment,
    };

    try {
        const response = await fetch(apiUrl, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
        });

        if (response.ok) {
            console.log(`Packing row with PackId ${pack_id} updated successfully.`);
            return true;
        } else {
            console.error("Failed to update packing row:", response.status, response.statusText);
            return false;
        }
    } catch (error) {
        console.error("Error in UpdatePackingRow API call:", error);
        return false;
    }
};

export const deletePackingByPackId = async (pack_id: number) => {
    const apiUrl = getApiUrl(`/api/TitelinePacking/DeletePackingByPackId/${pack_id}`);

    try {
        const response = await fetch(apiUrl, {
            method: "DELETE",
        });

        if (response.ok) {
            console.log(`Packing row with PackId ${pack_id} deleted successfully.`);
            return true;
        } else {
            console.error("Failed to delete packing row:", response.status, response.statusText);
            return false;
        }
    } catch (error) {
        console.error("Error in DeletePackingByPackId API call:", error);
        return false;
    }
};